import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    searchPlaceholder: string;
    recent: string;
    searchEmptyState: string;
    searchEmptyStateQuery: (query: string) => string | React.ReactNode;
    loadMore: (count: number) => string | React.ReactNode;
    spinnerAriaLabel: string;
    loadMoreSpinnerLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Placeholder text for project search */
            searchPlaceholder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccountProjectsView.searchPlaceholder?c=h565oekm3gd5", defaultMessage: "Find project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the recent projects group */
            recent: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccountProjectsView.recent?c=i947fswq5v0l", defaultMessage: "Recent" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Empty state message when no projects match search */
            searchEmptyState: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccountProjectsView.searchEmptyState?c=as11diiqch87", defaultMessage: "No projects matching" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Empty state query text for search */
            searchEmptyStateQuery: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (query: string) => __intl__.intl().formatMessage({ id: "AccountProjectsView.searchEmptyStateQuery?c=aka6ziwjznm5", defaultMessage: "\"{query}\"" }, { query: query }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to load more projects */
            loadMore: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "AccountProjectsView.loadMore?c=1vwza9qz22yvf", defaultMessage: "+{count} More" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label for the spinner */
            spinnerAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccountProjectsView.spinnerAriaLabel?c=25d15suvch2eq", defaultMessage: "Spinner" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label for the load more spinner */
            loadMoreSpinnerLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccountProjectsView.loadMoreSpinnerLabel?c=1ie8cjniv5k6c", defaultMessage: "Loading more projects" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
